// import { API } from 'aws-amplify';
import siteConfig from '@common/sites/site-config.json';
import { SiteConfigBase, SiteConfig } from '@common/@types/siteConfig';

// If we have site config verified from the server, we want to use that
let validatedSiteConfig: SiteConfig | null = null;

export async function getSiteConfig(): Promise<SiteConfig | null> {
  // It's not actually "validated" by the backend here, but while we're not
  // loading it from the backend, use this to cache it
  if (validatedSiteConfig) return validatedSiteConfig;

  // Get domain and TLD but not subdomain, use that to index siteConfig
  let domain = '';
  if (typeof window !== 'undefined') domain = window.location.hostname;
  const siteConfigKey = domain.split('.').slice(-2).join('.');

  // Return the config if it was in the JSON
  if (typeof siteConfigKey === 'string' && siteConfigKey in siteConfig) {
    const config = (siteConfig as SiteConfigBase)[siteConfigKey as keyof SiteConfigBase];
    config.domain = siteConfigKey;
    validatedSiteConfig = config;
    return config;
  }

  // Otherwise, null
  return null;
}

// To be re-enabled when we want the backend load
// TODO WHEN THAT HAPPENS: add `config.domain` on the backend and have it get returned.
// export async function getSiteConfig(): Promise<SiteConfig | null> {
//   // If the server has validated the Referer header, use that
//   if (validatedSiteConfig) return validatedSiteConfig;

//   // Otherwise:
//   try {
//     // Load the site config for the current site
//     const apiName = process.env.NEXT_PUBLIC_DASH_API_NAME!;
//     const path = `api/site-config`;
//     const myInit = {
//       headers: {},
//       queryStringParameters: {},
//     };
//     const response: SiteConfig = await API.get(apiName, path, myInit);

//     // If we get no data but it doesn't throw a 4xx, manually throw an error to load from the local config
//     if (!response) {
//       throw new Error('Invalid Dash frontend; api/site-config did not return a value.');
//     }

//     // If it succeeds, cache it
//     validatedSiteConfig = response;
//     return response;
//   } catch (error) {
//     // Otherwise: print the error
//     console.error(`Could not load siteConfig from server; defaulting to JSON. Error:`)
//     console.error(error);

//     // Get domain and TLD but not subdomain, use that to index siteConfig
//     const siteConfigKey = window.location.hostname.split('.').slice(-2).join('.');

//     // Return the config if it was in the JSON
//     if (typeof siteConfigKey === 'string' && siteConfigKey in siteConfig) {
//       return (siteConfig as SiteConfigBase)[siteConfigKey as keyof SiteConfigBase]
//     }

//     // Otherwise, null
//     return null;
//   }
// }
